import { useState } from "react";
import { toast } from "sonner";
import { Check, Trophy } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const WeeklyPlan = ({ program, onChanged, onWatch }) => {
  const [openDay, setOpenDay] = useState(0);
  const [busy, setBusy] = useState(null);
  const day = program.days[openDay];
  const pct = program.total ? Math.round((program.done / program.total) * 100) : 0;
  const tick = async (it) => {
    setBusy(it.exerciseId);
    try {
      const r = (await api.post("/client/me/program/tick", { dayIndex: openDay, exerciseId: it.exerciseId, done: !it.doneAt })).data;
      onChanged(r);
      if (r.fullWeek && !program.fullWeek) toast.success(`Full week! Every planned exercise done — that's ${r.fullWeeks} full week${r.fullWeeks !== 1 ? "s" : ""} stacked.`);
    }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className={`panel ${program.fullWeek ? "fullweek" : ""}`} data-testid="weekly-plan">
      <div className="ph">
        <h3>This week's plan · {program.name}</h3>
        <span className="ss num" data-testid="plan-week-progress">{program.done}/{program.total} done · {pct}%</span>
      </div>
      <div className="rbar" style={{ marginBottom: 12 }}><i style={{ width: `${pct}%` }} /></div>
      {program.fullWeek && <div className="fw" data-testid="plan-full-week"><Trophy size={14} /> <b>Full week complete.</b> Every planned exercise ticked off{program.fullWeeks > 1 ? ` · ${program.fullWeeks} full weeks stacked` : ""}. Rest up — the plan resets Monday.</div>}
      <div className="tabs">{program.days.map((d, i) => (
        <button key={i} className={openDay === i ? "on" : ""} onClick={() => setOpenDay(i)} data-testid={`plan-day-${i}`}>
          {d.name} <span className="num" style={{ opacity: .7 }}>{d.done}/{d.total}</span>{d.total > 0 && d.done === d.total ? " ✓" : ""}
        </button>))}
      </div>
      {day?.total > 0 && day.done === day.total && <div className="ss" style={{ marginBottom: 8 }} data-testid="plan-day-complete">Day complete — nice work.</div>}
      <table className="tbl" data-testid="plan-table"><thead><tr><th style={{ width: 36 }} /><th>Exercise</th><th>Sets × Reps</th><th>Load</th><th /></tr></thead>
        <tbody>{(day?.items || []).map((it, i) => (
          <tr key={it.exerciseId} data-testid={`plan-item-${i}`} style={{ opacity: it.doneAt ? .55 : 1 }}>
            <td><button className={`tick ${it.doneAt ? "on" : ""}`} disabled={busy === it.exerciseId} onClick={() => tick(it)} aria-label={it.doneAt ? "Mark not done" : "Mark done"} data-testid={`plan-tick-${i}`}>{it.doneAt && <Check size={13} />}</button></td>
            <td><b style={{ textDecoration: it.doneAt ? "line-through" : "none" }}>{it.exercise?.name}</b>{it.notes && <div className="ss">{it.notes}</div>}</td>
            <td className="num">{it.sets || "—"} × {it.reps || "—"}</td>
            <td className="num">{it.load || "—"}</td>
            <td><button className="btn sm g" onClick={onWatch} data-testid={`plan-watch-${i}`}>{it.watchedAt ? "Watched ✓" : "▶ Watch"}</button></td>
          </tr>))}</tbody></table>
    </div>
  );
};
